export default function defaultState() {
  return {
    fileGroups: [],
    isLoading: false,
  }
}
